import { GridCellProps } from '@progress/kendo-react-grid';
import { ApiEnums } from '../../Interfaces/ApiEnums';
import { registrationStatusesNameMap } from '../../utils/textMappings';
import { GetString } from '../StringResourceManager';

export const RegistrationStatusCell = (props: GridCellProps) => {
  const dataItem = props.dataItem;
  return (
    <td
      style={
        dataItem.ManagementAction == ApiEnums.ManagementActions.Decommissioned
          ? { backgroundColor: 'rgb(243, 23, 0, 0.32)', fontSize: '0.9rem' }
          : { fontSize: '0.9rem' }
      }
    >
      {GetString(
        registrationStatusesNameMap(
          dataItem.ManagementAction as ApiEnums.ManagementActions
        )
      )}
    </td>
  );
};
